import { useMemo } from 'react'
import {
  asText,
  type TitleField,
  type RichTextField,
  type FilledImageFieldImage,
  type PrismicError,
} from '@prismicio/client'
import type { UseQueryResult } from '@tanstack/react-query'
import { usePrismicID } from '@dhl/prismic'
import { getConfig } from '~/config/index.js'

type Promotion = {
  id: string
  surveyKey?: string
  title?: string
  image?: {
    url: string
  }
  description?: RichTextField | null
  optIn?: RichTextField | null
}

type PromotionResponse = {
  survey_key?: string
  title: TitleField
  image: FilledImageFieldImage
  description: RichTextField
  opt_in: RichTextField
}

export const usePromotion = (id: string, lang = ''): UseQueryResult<Promotion | undefined, PrismicError<Response>> => {
  const options = useMemo(
    () => ({
      lang,
    }),
    [lang]
  )
  const { prismic } = getConfig()

  return usePrismicID<PromotionResponse, Promotion | undefined>(
    { endpoint: prismic.endpoint, id, options },
    {
      query: {
        select: (response) =>
          response?.data
            ? {
                id,
                surveyKey: response.data.survey_key,
                title: asText(response.data.title),
                image: { ...response.data.image, url: response.data.image?.url?.replace(/\.gif.*/, '.gif') },
                description: response.data.description,
                optIn: response.data.opt_in,
              }
            : undefined,
      },
    }
  )
}
